/**
 *
 * 交通模拟
 *
 * 功能点:交通模拟演示
 * 场景:方案演示
 * 版本 1.0
 * 存疑 1.人工标点是否可以和CZML同时播放
 *     2.人工标点存储格式 是否和 CZML 一致
 */

import Vue from "@/main";
/**
 * 交通模拟 环境数据
 * @var graphicLayer - 交通模拟的图层
 * @var automobileList - 小车模型库
 *
 */
export let graphicLayer = [];
let automobileList = [
  {
    url: "/gltf/cart/kache3.gltf",
  },
  {
    url: "/gltf/cart/jiaobanche.glb",
  },
  {
    url: "/gltf/cart/benchi1.gltf",
  },
  {
    url: "/gltf/cart/red_car.gltf",
  },
  {
    url: "/gltf/cart/suv.gltf",
  },
];
/**
 * 交通模拟 数据
 * @var CZMLData - 交通模拟数据 重点
 * CZMLData中是个巨大的json 其中每一条数据代表一条模拟数据
 * 情况a：每一条模拟数据包含了以下几个对象
 * 1. beginDate - 起始时间 - 存疑（起始时间和结束时间如何设置,是否交由用户配置？会影响到多个CZML一起播放）解决方案为统一设置为：1995-02-08 00:00:00
 * 2. endDate - 结束时间 - 存疑（起始时间和结束时间如何设置,是否交由用户配置？会影响到多个CZML一起播放）解决方案为统一设置为：1995-02-08 23:59:59
 * 3. vehicleSum - 小车总数 - 每条线路的小车总数可以不相同 (经过讨论目前也不交由用户配置)
 * 4. carVelocity - 一台小车的速度 - 每辆小车的速度都可以不同
 * 5. intervalDate - 一台小车 两个坐标之间的时间间隔
 * 6. routePointSet - 车道的点集合
 * 情况b：每一条模拟数据是CZML文件的url（推荐此方法：原因是交通模拟数据量很大，很难去修改指定的某一辆车或一批车）
 * 1.参数是url
 *
 * 情况a - 编辑
 * @var routePointSet - 当前的车道点集合
 * @var requestData - 后台返回的数据集合 用于操作
 * @var vehicleSum - 当前小车总数
 * @var intervalDate - 一台小车 两个坐标之间的时间间隔
 * @var intervalvehicle - 一两台小车之前的时间间隔
 * @var beginDate - 起始时间
 * @var endDate - 结束时间
 * @var averageVelocity - 平均速度
 *
 */
export let CZMLData = [];
export let requestData = [];
export let routePointSet = [];
export let graphicDotsArr = [];
export let vehicleSum = 100;
export let intervalDate = 0;
export let intervalvehicle = 1;
export let beginDate = "1995-02-08T00:00:00.000Z";
export let endDate = "1995-02-08T23:59:59.000Z";
export let averageVelocity = 30;

/**
 * 辅助对象
 * 点图层 线图层
 * @var layerPoints - 车辆模拟坐标点图层 - 用于新增编辑车道点位
 * @var layerLine - 车辆模拟坐标线图层 - 用于展示车辆的路径
 * @var lineDataArr - 车辆模拟坐标线集合 - 用于展示车辆的路径
 *
 */
export let layerPoints;
export let layerLine;
export let lineDataArr = [];

/**
 * 初始化
 * 清空所有数据
 * @returns { any }
 */
export function init(type) {
  // 初始化点图层数据
  routePointSet = [];
  if (layerPoints && layerPoints != undefined) {
    Vue.$GLOBAL.map?.removeLayer(layerPoints);
    layerPoints = null;
  }

  // 初始化线图层数据
  if (layerLine && layerLine != undefined) {
    Vue.$GLOBAL.map?.removeLayer(layerLine);
    layerLine = null;
    lineDataArr = [];
  }
  clearCZML(type);
}

/**
 * 初始化
 * 刷新数据
 * @var data - 如果存在会更新速度 时间间隔
 * @returns { any }
 */
export function refresh(data) {
  init();
  // 点图层
  layerPoints = new mars3d.layer.GraphicLayer();
  Vue.$GLOBAL.map?.addLayer(layerPoints);
  if (data) {
    let { speed, interval } = data;
    if (speed) averageVelocity = Number(speed);
    if (interval) intervalvehicle = Number(interval);
  }
}

/**
 * 功能类
 * 添加车道点
 * 添加初始化车道点数据 - 逐一添加
 * @param  { string } label - 点的名称
 * @param  { function | null } addFn - 添加成功后的回调
 * @param  { function | null } editFn - 编辑成功后的回调
 * @returns { any }
 */
export function addPathPoint(label, addFn = () => {}, editFn = () => {}) {
  let rPColor = "#ffd700";
  let iurl = "/img/marker/mark" + rPColor.slice(1) + ".png";
  // layerPoints.hasEdit = true;
  let tempGL = layerPoints.startDraw({
    type: "billboard",
    style: {
      image: iurl,
      scale: 1,
      scaleByDistance_farValue: 0.2,
      scaleByDistance_far: 100000,
      scaleByDistance_near: 100,
      scaleByDistance_nearValue: 0.5,
      scaleByDistance: true,
      label: {
        //不需要文字时，去掉label配置即可
        text: label.toString(),
        font_size: 26,
        font_family: "黑体",
        color: rPColor,
        outline: true,
        pixelOffsetY: -35,
        visibleDepth: false,
        distanceDisplayCondition: true,
        distanceDisplayCondition_far: 10000,
        distanceDisplayCondition_near: 0,
      },
      visibleDepth: false,
      horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
      //clampToGround: true, //贴地
    },
    success: function(e) {
      e.startEditing();
    },
  });
  layerPoints.off(mars3d.EventType.editMovePoint);
  // graphicDotsArr = [];
  layerPoints.on(mars3d.EventType.drawCreated, function(e) {
    addFn ? addFn(e) : null;
  });
  layerPoints.on(mars3d.EventType.editMovePoint, function(e) {
    editFn ? editFn(e) : null;
  });
}

/**
 * 功能类
 * 展示路线点
 * @param  { object } arr - 点坐标的对象
 * @param  { string } type - 类型 支持单点绘制 'singlePoint'
 * @param  { function | null } editFn - 编辑成功后的回调
 * @returns { any }
 */
export function drawDots(arr, type, editFn = () => {}) {
  // 判断路径图层是否存在
  if (!layerPoints) {
    layerPoints = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(layerPoints);
  } else {
    // 清除路径图层内所有矢量数据
    layerPoints.clear();
  }
  let rPColor = "#ffd700";
  let iurl = "/img/marker/mark" + rPColor.slice(1) + ".png";
  let position, graphicDots;
  graphicDotsArr = [];
  arr.forEach((item) => {
    position = item.position
      ? item.position
      : JSON.parse(`[${item.bimTrafficSimulationContent.contentValue}]`);
    graphicDots = layerPoints.addGraphic([
      {
        type: "billboard",
        position: new mars3d.LngLatPoint(position[0], position[1], position[2]),
        style: {
          image: iurl,
          scale: 1,
          scaleByDistance_farValue: 0.2,
          scaleByDistance_far: 100000,
          scaleByDistance_near: 100,
          scaleByDistance_nearValue: 0.5,
          scaleByDistance: true,
          label: {
            //不需要文字时，去掉label配置即可
            text: item.text,
            font_size: 26,
            font_family: "黑体",
            color: rPColor,
            outline: true,
            pixelOffsetY: -35,
            visibleDepth: false,
            distanceDisplayCondition: true,
            distanceDisplayCondition_far: 10000,
            distanceDisplayCondition_near: 0,
          },
          visibleDepth: false,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。 //clampToGround: true, //贴地
        },
      },
    ]);
    graphicDotsArr.push(graphicDots);
    item.uid = graphicDots[0].uuid;
  }); // 单点查看会飞过去
  if (type == "singlePoint") {
    layerPoints.hasEdit = true;
    graphicDots[0].flyTo({
      radius: 2000,
    });
    layerPoints.on(mars3d.EventType.editMovePoint, function(e) {
      editFn ? editFn(e) : null;
    });
  }
}

/**
 * 功能类
 * 隐藏车道点
 * 隐藏车道点
 * @returns { any }
 */
export function clearDots() {
  layerPoints?.clear();
  routePointSet = [];
}

/**
 * 功能类
 * 添加车道线
 * 展示车道线数据
 * @param  { array } arr - 点坐标的集合
 * @param  { boolean  } ifFlyTo - 绘制完成是否会飞行
 * @returns { any }
 *
 */
export function drawLine(arr, ifFlyTo = false, show = true) {
  // 在创建线之前线清空所有线数据
  if (!layerLine) {
    layerLine = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(layerLine);
  } else {
    // 清除路径图层内所有矢量数据
    layerLine.clear();
  }

  let pointArr = arr.map((item) => {
    let [x, y, z] = item;
    return Cesium.Cartesian3.fromDegrees(x, y, z);
  });
  // console.log(pointArr);
  for (let i = 0; i < pointArr.length - 1; i++) {
    let position = mars3d.PolyUtil.getLinkedPointList(
      pointArr[i],
      pointArr[i + 1],
      0,
      50
    );
    lineDataArr[i] = new mars3d.graphic.PolylineEntity({
      positions: position,
      style: {
        width: 5,
        // 动画线材质
        material: mars3d.MaterialUtil.createMaterialProperty(
          mars3d.MaterialType.LineFlow,
          {
            color: "#ff0000",
            image: "/img/textures/lineAarrow.png",
            speed: 20,
            repeat: new Cesium.Cartesian2(5, 1),
          }
        ),
        show: show,
        depthFail: true,
        depthFailColor: "#ff0000",
        depthFailMaterial: mars3d.MaterialUtil.createMaterialProperty(
          mars3d.MaterialType.LineFlow,
          {
            color: "#ff0000",
            image: "/img/textures/lineAarrow.png",
            speed: 20,
            repeat: new Cesium.Cartesian2(5, 1),
          }
        ),
      },
    });
    // 添加线
    layerLine.addGraphic(lineDataArr[i]);
  }
  if (layerLine != undefined && ifFlyTo) {
    if (layerLine) {
      layerLine.flyTo();
    }
  }
}

/**
 * 功能类
 * 隐藏车道线
 * 隐藏车道线 同时把lineDataArr清空
 * @returns { any }
 */
export function clearLine() {
  layerLine?.clear();
  lineDataArr = [];
}

/**
 * 功能类
 * 开启交通模拟
 * 开启交通模拟入口
 * @param  { string } type -  预留type字段 考虑以后会出现 CZML 数据
 * @param  { string } id - 图层的id
 * @param  { boolean } fly - 是否飞行
 * @param  { array } arr - 点坐标的集合
 * @param  { Object } map - 地图
 * @returns { any }
 */
export function simulationStart(
  arr,
  id = "add",
  fly = false,
  type = "json",
  map = Vue.$GLOBAL.map
) {
  console.log(id);
  if (type == "json") {
    processingData(arr, id, fly, type, map);
  }
}

/**
 * 工具类
 * 处理数据 关键函数 服务于 simulationStart 函数
 * 把点集数据处理为CZML格式的数据
 * @param  { string } type -  预留type字段 考虑以后会出现 CZML 数据
 * @param  { string } id - 图层的id
 * @param  { boolean } fly - 是否飞行
 * @param  { array } arr - 点坐标的集合
 * @param  { Object } map - 地图
 * @returns { array } - 返回模拟 CZML 数据
 */
export function processingData(
  arr,
  id,
  fly,
  type = "json",
  map = Vue.$GLOBAL.map
) {
  // 当数据为json
  if (type == "json") {
    // czmlObj 初始化 czml 数据
    let czmlObj = [
      {
        version: "1.0",
        id: "document",
        clock: {
          interval: `${beginDate}/${endDate}`, //开始和结束时间
          currentTime: beginDate,
          multiplier: 1,
        },
        style: {
          distanceDisplayCondition: true,
          distanceDisplayCondition_far: 1000000,
          distanceDisplayCondition_near: 0,
        },
      },
    ]; // CZML固定头部

    let speed = 0;
    let initialSpeed = 0;
    arr.forEach((item) => {
      for (let i = 1; i <= vehicleSum; i++) {
        // i => 代表当前的小车
        let itemClone = JSON.parse(JSON.stringify(arr));
        itemClone.forEach((x, i) => {
          if (i > 0) {
            intervalDate =
              disTance(x, itemClone[i - 1].slice(1)) / averageVelocity;
          }
          speed += intervalDate;
          if (i == 0) {
            speed = initialSpeed;
          }
          if (x.length == 3) {
            x.unshift(speed); // 车速
          } else {
            x[0] = speed;
          }
        });
        initialSpeed += intervalvehicle;
        CZMLData = itemClone.reduce((a, b) => a.concat(b));
        let vehicle = {
          name: i,
          availability: `${beginDate}/${endDate}`,
          orientation: {
            velocityReference: "#position",
          },
          position: {
            epoch: beginDate,
            cartographicDegrees: CZMLData,
          },
          style: {
            minimumPixelSize: 100,
            distanceDisplayCondition: true,
            distanceDisplayCondition_near: 0,
            distanceDisplayCondition_far: 1300,
            distanceDisplayPoint: {
              // 当视角距离超过一定距离(distanceDisplayCondition_far定义的) 后显示为点对象的样式
              color: "#00ff00",
              pixelSize: 8,
            },
          },
          // },
          model: {
            show: true,
            // gltf: "/gltf/cart/kache3.gltf",
            gltf: randomVehicle(),
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            clampToGround: true,
            scale: 0.6,
            minimumPixelSize: 100,
            maximumScale: 1.5,
          },
          // label: {
          //   fillColor: {
          //     rgba: [0, 255, 255, 255],
          //   },
          //   font: "21pt Lucida Console",
          //   horizontalOrigin: "LEFT",
          //   outlineColor: {
          //     rgba: [0, 0, 0, 255],
          //   },
          //   outlineWidth: 2,
          //   pixelOffset: {
          //     cartesian2: [0, -30],
          //   },
          //   scale: 0.5,
          //   show: true,
          //   style: "FILL_AND_OUTLINE",
          //   text: createLicencePlate() + "--" + ++i,
          //   verticalOrigin: "CENTER",
          // },
        };
        czmlObj.push(vehicle);
      }
    });
    // console.log("匀速", czmlObj, arr);
    let CzmlLayerData = {
      name: "汽车",
      czmlId: id,
      data: czmlObj,
      autoUpdateClock: false,
      // clampToGround: true,
    };
    console.log(czmlObj, "czmlObjczmlObjczmlObjczmlObj");
    if (id == "add") {
      if (graphicLayer.length > 0) {
        graphicLayer.forEach((item) => {
          map.removeLayer(item);
          graphicLayer = [];
        });
      }

      graphicLayer[0] = new mars3d.layer.CzmlLayer(CzmlLayerData);
      map.addLayer(graphicLayer[0]);
      // console.log(graphicLayer);
    } else {
      // 这个地方有问题
      if (map.getLayer(id, "czmlId")) {
        map.getLayer(id, "czmlId")?.clear();
        map.removeLayer(map.getLayer(id, "czmlId"));
        let index;
        graphicLayer.find((e, i) => {
          if (e.options.czmlId == id) {
            index = i;
          }
        });
        graphicLayer.splice(index, 1);
      }
      let graphicLayerCurrent = new mars3d.layer.CzmlLayer(CzmlLayerData);
      map.addLayer(graphicLayerCurrent);
      graphicLayer.push(graphicLayerCurrent);
      if (fly) graphicLayerCurrent.flyTo();
    }
  }
}

/**
 * 工具类
 * 根据id初始化CZML图层
 * 把点集数据处理为CZML格式的数据
 * @param  { string } id - 图层的id
 * @returns { any }
 */
export function clearCZML(id) {
  if (id) {
    Vue.$GLOBAL.map
      .getLayer(id, "czmlId")
      ?.clear()
      .remove();
    let index;
    graphicLayer.find((e, i) => {
      if (e.options.czmlId == id) {
        index = i;
      }
    });
    graphicLayer.splice(index, 1);
  } else {
    if (graphicLayer.length > 0) {
      graphicLayer.forEach((item) => {
        Vue.$GLOBAL.map.removeLayer(item);
        graphicLayer = [];
      });
    }
  }
}

/**
 * 工具类
 * 随机生成小车模型
 * 把点集数据处理为CZML格式的数据
 * @returns { string } - 小车的url
 */
function randomVehicle() {
  let index = Math.round(Math.random() * (automobileList.length - 1));
  return automobileList[index].url;
}

/**
 * 工具类
 * 根据速度计算 两点之间的时间
 * @param  { array } positionsStart - 起始坐标
 * @param  { array } positionsEnd - 结束坐标
 * @returns { number } - 两点之间的时间
 *
 */
function disTance(positionsStart, positionsEnd) {
  let startPosition, endPosition, distance;
  startPosition = Cesium.Cartesian3.fromDegrees(...positionsStart);
  endPosition = Cesium.Cartesian3.fromDegrees(...positionsEnd);
  distance = Cesium.Cartesian3.distance(startPosition, endPosition);
  return distance;
}

/**
 * 工具类
 * 更新间隔时间  intervalvehicle
 * @param  { number } data - 更新数据
 * @returns { any }
 *
 */
export function postIntervalvehicle(data) {
  intervalvehicle = Number(data);
}

/**
 * 工具类
 * 更新平均速度  averageVelocity
 * @param  { number } data - 更新数据
 * @returns { any }
 *
 */
export function postAverageVelocity(data) {
  averageVelocity = Number(data);
}

/**
 * 工具类
 * 更新 requestData 数据
 * @param  { number } data - 更新数据
 * @returns { any }
 *
 */
export function getRequestData(data) {
  requestData = data;
}

/**
 * 工具类
 * 更新 vehicleSum 车俩总数 数据
 * @param  { number } data - 更新数据
 * @returns { any }
 *
 */
export function setVehicleSum(data) {
  vehicleSum = data;
}

/**
 * 工具类
 * 服务于 方案中的操作
 * @param  { number } data - 更新数据
 * @returns { any }
 *
 */
export function handleTrafficSimulation(type, id, fn, ...list) {
  // init();
  let map = Vue.$GLOBAL.map;
  if (list.length > 0) {
    let { mapType } = list[0];

    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
    }
  }
  let arr = [],
    interval,
    speed;
  requestData.forEach((item) => {
    if (item.id == id) {
      interval = item.bimTrafficSimulationNode.interval;
      speed = item.bimTrafficSimulationNode.speed;
      item.children.forEach((x) => {
        if (x.bimTrafficSimulationContent.contentValue)
          arr.push(x.bimTrafficSimulationContent.contentValue.split(","));
      });
    }
  });
  postAverageVelocity(speed);
  postIntervalvehicle(interval);
  simulationStart(arr, id, false, "json", map);
}

/**
 * 功能类
 * 飞行
 * @param  { string } id - 图层的id
 * @param  { Object } map - 地图
 * @returns { any }
 *
 */
export function flight(id, map = Vue.$GLOBAL.map) {
  if (map.getLayer(id, "czmlId")) {
    map.getLayer(id, "czmlId").flyTo();
  }
}
